import { useEffect, useRef, useState } from "react";
import socketIOClient from "socket.io-client";

const SOCKET_SERVER_URL = process.env.URL || 'https://cosint-backend.herokuapp.com';

const useChat = () => {
  const [messages, setMessages] = useState([]);
  const socketRef = useRef();

  useEffect(() => {
    socketRef.current = socketIOClient(SOCKET_SERVER_URL);

    socketRef.current.on("send message", (message) => {
      const incomingMessage = {
        ...message,
        ownedByCurrentUser: message.senderId === socketRef.current.id,
      };

      setMessages((messages) => [...messages, incomingMessage]);
    });

    return () => {
      socketRef.current.disconnect();
    };
  }, []);

  const sendMessage = (message) => {
    socketRef.current.emit("send message", {
      message: message.message,
      senderId: socketRef.current.id,
      name: message.name
    });
  };

  const setName = (name) => {
    socketRef.current.emit("set name", {
      name: name,
      senderId: socketRef.current.id
    });
  };

  return { messages, sendMessage, setName };
};

export default useChat;
